import $ from 'jquery';
import validate from "jquery-validation";

//validate form
let form = $('.js-form'),
	url = form.attr('action');
$.validator.messages.required = 'Заполните поле';
form.each(function(){
	let thisForm = $(this);
	thisForm.validate({
		focusInvalid: false,
		onkeyup: false,
		highlight: function(element) {
			$(element).parent('.js-group').addClass('form__group--error');
		},
		unhighlight: function(element) {
			$(element).parent('.js-group').removeClass('form__group--error');
		},
		submitHandler: function(form, event){
			event.preventDefault();
			var data = new FormData(),
				formParams = thisForm.serializeArray();

			$.each(thisForm.find('.js-input-file'), function(i, tag) {
				$.each($(tag)[0].files, function(i, file) {
					data.append(tag.name, file);
				});
			});

			$.each(formParams, function(i, val) {
				data.append(val.name, val.value);
			});

			data.append('key', 'value');

			if (thisForm.data('label') === 'open-popup') {
				$('.popup').removeClass('active').addClass('inactive');
				$('#thank_you').addClass('active');
			}

			// TODO IMPLEMENT AJAX LOGIC

			//$('#popup-thank').fadeIn();
			// $('.popup').removeClass('is-show');

			/* ******* */
			$.ajax({
				url: thisForm[0].action,
				type: 'POST',
				processData: false,
				contentType: false,
				data: data,
				beforeSend: function (data) {
					thisForm.find('button').attr('disabled', 'disabled');
				},
				success: function (data) {
					if (data['error']) {
						console.log('error');
					} else {
						setTimeout(function () {
							thisForm.find('.btn.submit').removeClass('active');
							thisForm.find('button').prop('disabled', false);
							thisForm[0].reset();
							$('.popup').removeClass('is-show');
							$('#popup-thank').addClass('active');
						}, 500);
					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				}
			});
			return false;
		}
	});

	var agree = $('.js-agreement');
	if (agree.length) {
		if (agree.is(':not(:checked)')) {
			thisForm.find('button').prop('disabled', true);
		}
	}

	$('.js-phone').keypress(function(e){
		var charCode = (e.which) ? e.which : e.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	})

})
